import React from 'react';
import { Collapse } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DownOutlined, ReconciliationOutlined } from '@ant-design/icons';

import { PrimaryButton } from '@/components/ui/Button/Primary';
import { ActionPlanPanelContent } from '@/components/views/Report/KimLhc/Report/Steps/Result/ActionPlan';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

const { Panel } = Collapse;

interface ActionPlanSectionProps {
	onOpenModal: () => void;
	onEditActionPlan: (id: string) => void;
}

export function ActionPlanSection({ onOpenModal, onEditActionPlan }: Readonly<ActionPlanSectionProps>): JSX.Element {
	function renderExpandIcon({ isActive }: { isActive?: boolean }) {
		return <DownOutlined rotate={isActive ? 180 : 0} />;
	}

	function handleCreateActionPlan(e: React.MouseEvent) {
		e.stopPropagation();
		onOpenModal();
	}

	return (
		<S.StyledCollapse expandIconPosition="end" expandIcon={renderExpandIcon}>
			<Panel
				key="action-plans"
				header={
					<S.CategoryHeader>
						<S.AccordionTitle>{I18n.get('Action plans')}</S.AccordionTitle>
						<PrimaryButton
							style={{ width: 'auto', position: 'absolute', right: '3.5rem' }}
							onClick={handleCreateActionPlan}
							icon={<ReconciliationOutlined />}
						>
							{I18n.get('Create action plan')}
						</PrimaryButton>
					</S.CategoryHeader>
				}
			>
				<ActionPlanPanelContent onEditActionPlan={onEditActionPlan} />
			</Panel>
		</S.StyledCollapse>
	);
}
